/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { TAGTYPES_SAVE_REQUEST, success, failure } from './action';

const saveTagTypes = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(TAGTYPES_SAVE_REQUEST)
    .map(({ data }) => data)
    .mergeMap((params) =>
      AjaxRequest.open(
        'post',
        `/admin/tag/tagtype`,
        params,
      )('tudo')
        .flatMap((data) => Observable.of(success(data.response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(saveTagTypes);
